<template>
  <div class="data-page">
    <top-bar :topbarList="msgTopBarList"></top-bar>
    <router-view></router-view>
  </div>
</template>

<script>
import topBar from "@/components/topBar.vue";
import { msgIndexMixins } from "@/mixins/msgIndexMixins";

export default {
  mixins: [msgIndexMixins],
  data() {
    return {};
  },
  computed: {},
  components: {
    topBar,
  },
};
</script>

<style lang="less" scoped>
.data-page {
  height: 100%;
}
</style>
